
<template>

    <section class="invoices">

        <div class="panel">
<!--             <div class="panel-heading"><h2>Invoices</h2></div>
            <div class="panel-body">
                <table class="table table-striped table-bordered" v-if="invoices">
                    <thead>
                        <tr>
                            <th>Invoice number</th>
                            <th>Amount</th>
                            <th>Due On</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="invoice in invoices">
                            <td>{{invoice.invoiceNumber}}</td>
                            <td>${{invoice.amount}} <span v-if="isPaid(invoice.amount, invoice.payment)">PAID</span></td>
                            <td><span v-if="invoice.dueDate">{{invoice.dueDate | localDate}}</span></td>
                            <td>
                                <button @click.prevent="openInvoice(invoice.id)" class="btn btn-sm btn-success">Open</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p>Invoices open in a new window; please ensure your browser doesn't block pop-ups.</p>
            </div> -->
        </div>

    </section>

</template>

<script>

import invoices from '../services/invoices';

export default {
    data() {
        return {
            invoices: null
        }
    },
    components: {

    },
    mounted() {
        this.getInvoices();
    },
    methods: {
        isPaid(amount, payments) {

            if (payments.length === 0) {
                return 'red';
            }

            let totalAmountPaid = payments.reduce(function(a,b) {
                return parseFloat(a.amount) + parseFloat(b.amount);
            });
            if (totalAmountPaid < amount) {
                return 'red';
            }
            
            return 'green';
        },
        openInvoice(invoiceId) {
            invoices.getLink(this, invoiceId).then(function(response) {
                window.open(response.data.url,'_blank');
            })
        },

        getInvoices() {
            var self = this;
            invoices.get(this).then(function(response) {
                self.invoices = response.data.invoices
            })
        }
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
    .panel {
        margin-top:3rem;
        p {
            text-align:right;
            padding-right:2rem;
        }
    }
</style>


// WEBPACK FOOTER //
// Invoices.vue?7e984b76